import * as types from "./mutation-types";

const state = () => {
  return {
    darkMode: false,
    User: false
  };
};

// getters
const getters = {
  darkMode: state => state.darkMode
};

// actions
const actions = {
  setDarkMode({ commit }, darkMode) {
    commit(types.SET_DARK_MODE, { darkMode });
  },
  setUserLogged({ commit }, User) {
    commit(types.SET_USER_LOGGED, { User });
  }
};

// mutations
const mutations = {
  [types.SET_DARK_MODE](state, { darkMode }) {
    state.darkMode = darkMode;
  },
  [types.SET_USER_LOGGED](state, { User }) {
    state.User = User;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
